import React, {Component} from "react";
import {FormattedMessage} from "react-intl";

let layers = [
    {id: 1, checked: true, text: 4, name: "layer"},
    {id: 2, checked: false, text: 6, name: "layer"},
];

class Layers extends Component {

    constructor(){
        super();

        this.state = {
            white: false,
            whiteBtn6: true
        }
    }
    changeColor(){
        this.setState({white: !this.state.white});
        if(this.state.whiteBtn6===false){
            this.setState({whiteBtn6: !this.state.whiteBtn6});
        }
        this.props.setThicknessForSelectedLayer(false);
    }
    changeColor6(){
        this.setState({whiteBtn6: !this.state.whiteBtn6});
        if(this.state.white===false){
            this.setState({white: !this.state.white})
        }
        this.props.setThicknessForSelectedLayer(true);
    }

    render() {
        let btn_class = this.state.white ? "imp-item-btn btn" : "imp-item-selected-btn btn";
        let btn_class_6 = this.state.whiteBtn6 ? "imp-item-btn btn" : "imp-item-selected-btn btn";
        return (
            <div className="row">
                <div className="col-md-12 no-padding">
                    <div className="pcb-details-div">
                        <div className="col-md-3 text-right calc-item-heading">
                            <FormattedMessage id="app.pcb-quotation.pcb-layers"
                                              defaultMessage="Layers"
                                              description=""
                            />
                            &nbsp; &nbsp;
                        </div>

                        <div className="col-md-8 pcb-details-div-items">
                            <button className={btn_class}
                                    onClick={this.changeColor.bind(this)}>4-layer</button>
                            <button className={btn_class_6}
                                    onClick={this.changeColor6.bind(this)}>6-layer</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Layers;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/ImpedanceCalculator/CustomizationFormFields/Layers.js